export default {
    CREATE_AUTOMATIONS: () => '/rule/createRule',
    GET_BY_ID_AUTOMATIONS: (id) => `/rule/getRuleBy/${id}`,
    GET_ALL_AUTOMATIONS: () => `/rule/getAllRule`,
    DELETE_BY_ID_AUTOMATIONS: (id) => `/rule/deleteRule/${id}`,
    UPDATE_AUTOMATIONS: (id) => `/rule/updateRule/${id}`,
};
